import { render, staticRenderFns } from "./NewCardModal.vue?vue&type=template&id=d2884f34&scoped=true"
import script from "./NewCardModal.vue?vue&type=script&lang=js"
export * from "./NewCardModal.vue?vue&type=script&lang=js"
import style0 from "./NewCardModal.vue?vue&type=style&index=0&id=d2884f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2884f34",
  null
  
)

export default component.exports